import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { BookmarkPlus, Check } from "lucide-react";
import { useAuth, signInWithGoogle } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/account/dogs`;
const KEY = "dp_pending_dog";

export const takePendingDog = () => {
  try {
    const raw = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const btn = "flex items-center gap-2 text-[14px] font-medium text-[#D2C08E] hover:text-[#E8DDC7] transition-colors duration-300 disabled:opacity-40";

export const QuizSaveDog = ({ dog, t }) => {
  const { user } = useAuth();
  const [state, setState] = useState("idle");

  if (!user) {
    return (
      <button data-testid="slip-signin-save" className={btn}
        onClick={() => { localStorage.setItem(KEY, JSON.stringify(dog)); signInWithGoogle(); }}>
        <BookmarkPlus className="w-3.5 h-3.5" /> {t("Sign in to save this dog", "Connectez-vous pour enregistrer ce chien")}
      </button>
    );
  }
  if (state === "saved") {
    return (
      <Link to="/account" data-testid="slip-saved-link" className={`${btn} border-[#8FB08A]/60 text-[#8FB08A]`}>
        <Check className="w-3.5 h-3.5" /> {t(`${dog.name} is saved · view`, `${dog.name} est enregistré · voir`)}
      </Link>
    );
  }
  const save = async () => {
    setState("saving");
    try {
      await axios.post(API, dog, { withCredentials: true });
      setState("saved");
    } catch {
      setState("error");
    }
  };
  return (
    <div className="flex flex-col gap-1">
      <button data-testid="slip-save-dog" onClick={save} disabled={state === "saving"} className={btn}>
        <BookmarkPlus className="w-3.5 h-3.5" /> {state === "saving" ? t("Saving…", "Enregistrement…") : t("Save to my dogs", "Enregistrer dans mes chiens")}
      </button>
      {state === "error" && <span data-testid="slip-save-error" className="text-[12px] text-[#C9876B]">{t("That didn't save. Please try again.", "L'enregistrement a échoué. Veuillez réessayer.")}</span>}
    </div>
  );
};
